import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const postForgotPasswordActionTypes = {
  ...apiPromiseTypes('forgotpassword', 'post'),
};

export const RESET_EMAIL = 'waitrose/forgotpassword/RESET_EMAIL';
